import { useQuery } from "@tanstack/react-query";

import api from "../../services/api";
import { queryKeys } from "../api/queryKeys";

/** Mesmo staleTime das queries que consomem o token (banners, popups). */
export const BANNERS_MARKETING_STALE_MS = 15 * 60 * 1000;

export const useBannersToken = () => {
  return useQuery<{ token: string }>({
    queryKey: queryKeys.bannersToken,
    queryFn: async () => {
      const { data } = await api.get<{ token: string }>(
        "cliente/banners/token",
      );
      return data;
    },
    staleTime: BANNERS_MARKETING_STALE_MS,
  });
};
